import { Controller } from '@hotwired/stimulus'

export default class UserRegistrationController extends Controller {
  static targets = ['submitButton', 'emailInput'];

  toggleSubmitButton() {
    this.submitButtonTarget.disabled = !this.emailInputTarget.checkValidity();
  }
}
